import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Guards authenticated routes.
 *
 * - While the app is restoring the Cognito session on first load (isInitializing),
 *   renders nothing to avoid a flash-redirect to /login.
 * - Once initialisation settles: redirects to /login if not authenticated,
 *   or renders children if authenticated.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isInitializing = useSelector((state: RootState) => state.auth.isInitializing);
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  if (isInitializing) return null;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
